import React from 'react';
import PropTypes from 'prop-types';

import SystemLogsTable from '../components/systemLogs/systemLogsTable';

import 'react-day-picker/lib/style.css';

const PAGE_SIZES = [50, 100, 200, 500, 1000, 2000, 5000];

class LogsPage extends React.PureComponent {
    state = {
        page: 0,
        filters: {},
    };

    componentDidMount() {
        this.loadMore();
    }

    loadMore = () => {
        this.props.getLogsList({ page: this.state.page + 1, ...this.state.filters });
        this.setState({
            page: this.state.page + 1,
        });
    };

    filterLogs = filters => {
        this.props.getLogsList({ page: 1, ...filters });

        this.setState({
            page: 1,
            filters,
        });
    };

    render() {
        return (
            <div>
                <h1>{this.props.title}</h1>
                {this.props.renderFilters({ filterLogs: this.filterLogs, pageSizes: PAGE_SIZES })}
                <SystemLogsTable items={this.props.logs} />
                {this.props.logs.length && this.props.hasMore ? (
                    <button type="button" onClick={this.loadMore} className="systemlog-loadmore">
                        Load more
                    </button>
                ) : null}
            </div>
        );
    }
}

LogsPage.propTypes = {
    title: PropTypes.string.isRequired,
    getLogsList: PropTypes.func.isRequired,
    logs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hasMore: PropTypes.bool.isRequired,
    renderFilters: PropTypes.func.isRequired,
};

export default LogsPage;



// WEBPACK FOOTER //
// ./source/screens/LogsPage.js